// LineItemsCell.js
import React from "react";

const LineItemsCell = ({ line_items_json, quantity, item_type }) => {
    let content = "-";

    if (line_items_json) {
        try {
            const items = JSON.parse(line_items_json);
            const showTotal = items.length > 1;

            content = items
                .map(
                    (item) =>
                        `${item.quantity} x ${item.meta_data?.[0]?.value || item.name
                        }${showTotal ? ` ($${item.total})` : ""}`
                )
                .join("\n");
        } catch (e) {
            content = "Invalid data";
        }
    } else if (quantity) {
        content = `${quantity} x ${item_type}`;
    }

    return <td style={{ whiteSpace: "pre-line" }}>{content}</td>;
};

export default LineItemsCell;